import styled from "styled-components";

export const RightRailWrap = styled.div`
  > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.space.md};
  }
`;
